import 'isomorphic-fetch';
import { camelizeKeys, pascalizeKeys } from 'humps';
import queryString from 'query-string';
import { cloneDeep } from 'lodash';

export const CALL_API = Symbol('Call API');
export const CONTENT_TYPE = {
  JSON: Symbol('json'),
  FORM: Symbol('form'),
};

function callApi(url, params, method = 'GET', type = CONTENT_TYPE.JSON, headers = {}, shouldCamelizedJson = true) {
  let fullUrl = url;
  const fetchOptions = {
    mode: 'cors',
    method,
    headers: cloneDeep(headers),
    credentials: 'include',
  };

  switch (type) {
    case CONTENT_TYPE.JSON:
      fetchOptions.headers['Content-Type'] = 'application/json';
      if (typeof(params) !== 'undefined' && method === 'GET') {
        fullUrl += '?' + queryString.stringify(params);
      } else if (typeof params !== 'undefined') {
        fetchOptions.body = JSON.stringify(pascalizeKeys(params));
      }
      break;
    case CONTENT_TYPE.FORM:
      if (typeof(params) !== 'undefined') {
        fetchOptions.body = params;
      }
      break;
    default:
      break;
  }

  return fetch(fullUrl, fetchOptions)
  .then(response => {
    const resStatus = Number(response.status);
    if (!response.ok && (resStatus === 401 || resStatus === 403)) {
      return {
        json: {
          error: {
            'status': resStatus,
            'httpStatus': resStatus,
          },
        },
        response,
      };
    }

    return response.json().then(json => {
      return { json, response };
    });
  })
  .then(({ json, response }) => {
    const resStatus = Number(response.status);
    const camelizedJson = camelizeKeys(json);
    if (typeof(camelizedJson.error) !== 'undefined') {
      return Promise.reject({
        'status': camelizedJson.error.status,
        'message': camelizedJson.error.detail,
        'httpStatus': resStatus,
        'others': camelizedJson.error.mulitiDetail,
      });
    }

    if (!response.ok) {
      return Promise.reject({
        'status': resStatus,
        'message': camelizedJson.message || response.statusText,
        'httpStatus': resStatus,
      });
    }
    if (!shouldCamelizedJson) {
      return json;
    }
    return camelizedJson;
  });
}

export default store => next => action => {
  const { app: { application } } = store.getState();
  const callAPI = action[CALL_API];

  if (typeof(callAPI) === 'undefined') {
    return next(action);
  }

  function actionWith(data) {
    const finalAction = Object.assign({}, action, data);
    delete finalAction[CALL_API];
    return finalAction;
  }

  const { types, params, method, contentType, url, onSuccess, onFail, shouldCamelizedJson, headers = {} } = callAPI;
  const [requestType, successType, failureType] = types;
  next(actionWith({
    type: requestType,
  }));

  return callApi(url, params, method, contentType, Object.assign({}, application.headers, headers), shouldCamelizedJson).then(
      response => {
        next(actionWith({
          response,
          type: successType,
        }));

        if (typeof onSuccess === 'function') {
          onSuccess(response);
        }

        return Promise.resolve(response);
      },
      (error) => {
        next(actionWith({
          type: failureType,
          error,
        }));

        if (typeof onFail === 'function') {
          onFail(error);
        }

        return Promise.reject(error);
      }
  );
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/middlewares/api.js
 **/